<template>
  <div class="container">
    <!-- <h2>CryptoNinja Partners 合成サイト（非公式）</h2> -->
    <h2>Aopanda PartyのPFPを作成しよう🐼</h2>
    <br/>

      <!-- 1. メタマスクが使えないブラウザ -->
      <template v-if="!canUseMetaMask()">
        <div>ブラウザでメタマスクが使える状態になっていません</div>
      </template>
      <!-- 2. メタマスク未接続 -->
      <template v-else-if="!connectedMetaMask()">
        <div class="form-label text-body">あなたのAPPに今すぐ背景を合成できます！</div><br/>
        <div class="form-label text-body">APPを保有しているメタマスクで接続してください</div><br/>
        <div class="form-label text-body">※接続のみで署名確認は一切ありません</div><br/><br/>

        <div class="form-label text-body">You can compose a background for your APP now!</div><br/>
        <div class="form-label text-body">Connect with a metamask that possesses APP</div><br/>
        <div class="form-label text-body">*No signature verification at all, just a connection.</div><br/><br/>

        <button class="btn btn-primary my-md-4 w-180px" @click="onClickConnect">Wallet Conect!</button><br/>
        <div v-show="networkchange" class="form-label text-danger font-weight-bold">Change Mainnet!</div>
      </template>
      <!-- 3. その他(メタマスク接続済) -->
      <template v-else>
        <div v-show="loading" class="loader">Now loading...</div>
        <div v-if="!loading">
            <div v-if="array_contractInfo.length == 0">
              <div class="form-label text-body">APPをお持ちでありません。。OpenSeaで購入してみよう！</div><br/>
              <div class="form-label text-body">Don't have APP? Buy it at OpenSea!</div><br/><br/>
              <a href="https://opensea.io/ja/collection/aopanda-party/" target="_blank" v-show="!loading">OpenSeaを見てみる。</a>
            </div>
            <div v-else>
              <div class="form-label text-body h5">合成したいAPP画像を選ぶパンッ♫</div><br/>
              <div class="form-label text-body h5">Select the APP image</div><br/>
              <div class="collection-detail">
                <div  v-for="(tokenid,index_token) in array_tokenid[selectcollection]" :key="tokenid.Object">
                    <img :id="`image${index_token}`" :src="array_tokenid[selectcollection][index_token].image" height="150" class="shadow p-1 mb-3 bg-white rounded imagebox" @click="onSelectNFT(index_token)">
                    <div class="box">{{array_tokenid[selectcollection][index_token].title}}</div>
                </div>
              </div> 
              <br/><br/>
              <hr size = "0.5" width="100%">

              <div class="form-label text-body h5">合成したい背景画像を選ぶパンッ♫</div><br/>
              <div class="form-label text-body h5">Select the background image</div><br/><br/>
              <!-- <label for="back-select">Choose a pet:</label> -->
              <select  id="back-select"  v-model="selectedseries" @change="onSelecSeries()">
                  <!-- <option value="">--壁紙シリーズを選択--</option> -->
                  <option value=1>01.orange-base</option>
                  <option value=2>02.yellow-base</option>
                  <option value=3>03.yellow-green-base</option>
                  <option value=4>04.green-base</option>
                  <option value=5>05.blue-green base</option>
                  <option value=6>06.light-blue-base</option>
                  <option value=7>07.blue base</option>
                  <option value=8>08.purple-base</option>
                  <option value=9>09.purple-pink base</option>
                  <option value=10>10.pink-base</option>
                  <option value=11>11.peach-pink-base</option>
                  <option value=12>12.white-base</option>
                  <option value=13>13.ぬあー (´·ω·´)さん</option>
                  <option value=14>14.GAIさん</option>
                  <option value=15>15.DAIKIさん</option>
                  <option value=16>16.まじこれさん</option>
                  <option value=17>17.じんさん</option>
              </select>

              <div class="collection-detail">
                <div  v-for="(part,index) in array_backparts" :key="index">
                    <img :id="`parts${index}`" :src="part" height="150" class="shadow p-1 mb-3 bg-white rounded imagebox" @click="onSelectParts(index)">
                </div>
              </div> 

              <br/><br/>
              <div v-if="selectedseries == 13">
                <a href="https://twitter.com/Nuaah_Box/" target="_blank" v-show="!loading">ぬあー (´·ω·´)さんのTwitterはこちら🔗</a><br/><br/>
              </div>
              <div v-if="selectedseries == 14">
                <a href="https://twitter.com/kamibukuro18/" target="_blank" v-show="!loading">GAIさんのTwitterはこちら🔗</a><br/><br/>
              </div>
              <div v-if="selectedseries == 15">
                <a href="https://twitter.com/MNursemanDAIKI/" target="_blank" v-show="!loading">DAIKIさんのTwitterはこちら🔗</a><br/><br/>
              </div>
              <div v-if="selectedseries == 16">
                <a href="https://twitter.com/maji_colle/" target="_blank" v-show="!loading">まじこれさんのTwitterはこちら🔗</a><br/><br/>
              </div>
              <div v-if="selectedseries == 17">
                <a href="https://twitter.com/shodojin_/" target="_blank" v-show="!loading">じんさんのTwitterはこちら🔗</a><br/><br/>
              </div>
              <hr size = "0.5" width="100%">

              <div class="form-label text-body h5">作成したい画像の種類を選ぶパンッ♫</div><br/>
              <div class="form-label text-body h5">Select the type of image</div><br/><br/>

              <div class="StatsInfoStyle">
                <input type="radio" id="option1" value="select1" v-model="concatmode" v-on:change="onRadioChange" />
                <label for="option1">動かない画像にする（png）</label>
                <br>
                <input type="radio" id="option2" value="select2" v-model="concatmode" v-on:change="onRadioChange"/>
                <label for="option2">ぴょこぴょこさせる（gif）</label>
                <br/><br/>
                <input id="mini" type="checkbox" v-model="mini" /><label for="mini">（オプション）APPを少し小さくする</label>
              </div>

              <br/><br/>
              <hr size = "0.5" width="100%">

              <div v-if="concatmode == 'select1'">
                  <div v-if="ConcatLoad == false">
                    <br/>
                    <button class="btn btn-primary w-180px" @click="onClickConcat">Go!!</button><br/><br/>
                  </div>
                  <div v-else>
                    <button class="btn btn-primary w-180px" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </button>
                  </div>

                  <canvas id="base" v-show="false"></canvas>
                  <canvas id="asset" v-show="false"></canvas>
                  <canvas v-show="isdownload && ConcatLoad == false"  id="concat" width="700" height="700" style="width:250px" class="shadow p-1 mb-3 bg-white rounded imagebox"></canvas><br/><br/>
                  <button v-show="isdownload && ConcatLoad == false"  class="btn btn-danger w-180px" @click="onClickDownload">Download</button><br/><br/>
              </div>
              <div v-else>
                <div v-if="ConcatLoad == false">
                    <br/>
                    <button class="btn btn-primary w-180px" @click="onClickConcat_gif">Go!!</button><br/><br/>
                  </div>
                  <div v-else>
                    <button class="btn btn-primary w-180px" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </button>
                  </div>
                <img v-show="isdownload && ConcatLoad == false" id="gifconcat" :src= "base64gif" height="250" class="shadow p-1 mb-3 bg-white rounded imagebox" /><br/><br/>
                <button v-show="isdownload && ConcatLoad == false"  class="btn btn-danger w-180px" @click="onClickDownloadGif">Download</button><br/><br/>
              </div>
            </div>          
        </div>

      </template>
      
  </div>
</template>

<script>
//import { ethers } from "ethers";
import axios from 'axios';
import {
  Network,
  Alchemy
} from "alchemy-sdk";

const sleep = waitTime => new Promise( resolve => setTimeout(resolve, waitTime) );

const settings = {
  apiKey: process.env.VUE_APP_ALCHEMY_API_KEY, // Replace with your Alchemy API Key.
  network: Network.ETH_MAINNET,
  // network: Network.MATIC_MUMBAI, // Replace with your network.  //!
  maxRetries: 10,
};

const BACK_URL = "https://nft.aopanda.ainy-llc.com/appback";
const GOUSEI_GIF_API = "https://express.japaneast.cloudapp.azure.com/gouseigif/"; 

const SeriesCount = [5,5,5,5,5,5,5,5,5,5,5,5,13,3,16,3,7];

export default {
    data(){
        return{
            // 小文字で!!!!!!!
            // contract_address : '0x845a007d9f283614f403a24e3eb3455f720559ca',
            contract_address : '0xc7e4d1dfb2ffda31f27c6047479dfa7998a07d47',  //!
            connect:null,
            ethereum:null,
            array_contract:{},
            array_tokenid:{},
            array_contractInfo:[],
            array_statsInfo:[],
            array_backparts:[],
            loading: false,
            networkchange:false,
            selectcollection:0,
            selectnft_index:0,
            selectparts_index:0,
            selectnft:'#image0',
            selectparts:'#parts0',
            selectedseries:1,
            width:700,
            height:700,
            mini:false,
            isdownload:false,
            ConcatLoad:false,
            concatmode:'select1',
            base64gif:'',

        }
    },
  mounted () {
      this.ethereum = window.ethereum
      for(let cnt=0;cnt < 5;cnt++){
          this.array_backparts[cnt] = "/back_01_" + ('000' + (cnt+1)).slice(-3) + ".png";
      }
  },
  methods: {
      async onSelecSeries(){
        this.array_backparts =[]; //配列クリア
        this.selectparts_index = 0;
        let maxcnt = SeriesCount[this.selectedseries -1];

        for(let cnt=0;cnt < maxcnt;cnt++){
          this.array_backparts[cnt] = "/back_" + ('00' + this.selectedseries).slice(-2) + "_" + ('000' + (cnt+1)).slice(-3) + ".png";
        }
      },
      async onClickConnect () {
      // walletアドレス取得
      if(this.ethereum.chainId === '0x1'){
        // if(this.ethereum.chainId === '0x5'){
        this.networkchange = false;
        const accounts = await this.ethereum.request({ method: 'eth_requestAccounts' })
        const account = accounts[0]
        this.connect = account
        console.log("walletaddress:",account)

        this.loading = true;

        let maxget = true;
        let getpageKey = undefined;

        // コレクションの取得
        const alchemy = new Alchemy(settings)

        let index_0 = 0,index_1 = 0,preconstract = "";
          let temparray = [];

        while(maxget  == true){
          let nftsForOwner = await alchemy.nft.getNftsForOwner(this.connect,{pageKey:getpageKey});
          console.log("number of NFTs found:", nftsForOwner);
          if(nftsForOwner.pageKey != undefined){
            console.log("pageKey:", nftsForOwner.pageKey);
            getpageKey = nftsForOwner.pageKey;
          }else{
            maxget = false;
          }

          for (const nft of nftsForOwner.ownedNfts) {
            if(nft.contract.address != this.contract_address){
              console.log("no target:",nft.contract.address);
              continue; // no target
            }
            console.log(nft.contract.address);
            if(preconstract != nft.contract.address){        
              const response = await axios.get(`https://api.opensea.io/api/v1/asset_contract/${nft.contract.address}`)
              // const response = await axios.get(`https://testnets-api.opensea.io/api/v1/asset_contract/${nft.contract.address}`)
              // if(response.data.image_url == null){
              //   console.log("invalid data");
              //   continue; //invalid data
              // }

              if(preconstract != ""){ 
                  //Other Frist Time
                  this.$set(this.array_tokenid, index_0, temparray);  //temp->add (for two-dime array)
                  temparray = [];
                  index_0++;
                  index_1 =0; // init
              }

              this.$set(this.array_contract, index_0, nft.contract.address); 
              this.$set(this.array_contractInfo, index_0, response.data);
              this.$set(this.array_tokenid, index_0, "");
              // Opensea Stats get
              // const slug = response.data.collection.slug;
              // const response_stats = await axios.get(`https://api.opensea.io/api/v1/collection/${slug}/stats`);
              // this.array_statsInfo[index_0] = response_stats.data;
              //console.log(this.array_statsInfo[index_0]);
            }
            // tokeid info push
            const response = await alchemy.nft.getNftMetadata( nft.contract.address,nft.tokenId);
            //console.log("getNftMetadata:", response);
            // ipfs対策
            var check = String(response.rawMetadata.image);
            if(!check.indexOf('ipfs://')){
              console.log("check!true:", response.rawMetadata.image);
              check = check.replace('ipfs://','https://ipfs.io/ipfs/');
              response.rawMetadata.image = check;
              console.log("check!replace:", response.rawMetadata.image);
            }
            this.$set(temparray, index_1, {contract:response.contract.address,id:response.tokenId,title:response.title,image:response.rawMetadata.image});

            index_1++;
            preconstract =  nft.contract.address;
          }
          this.$set(this.array_tokenid, index_0, temparray);  //last push
        }
        this.loading = false;
        
      }else{
        this.networkchange = true;
      }
    },
    // ブラウザでメタマスクが使える状態かどうかを返す
    canUseMetaMask () {
      //console.log(this.ethereum)
      return this.ethereum !== undefined;
    },
    // メタマスクに接続されているかどうかを返す
    connectedMetaMask () {
      //console.log(this.connect)
      return this.canUseMetaMask() && this.connect != null;
    },
    // connectedTargetNetwork () {
    //   console.log(this.ethereum.chainId )
    //   return this.connectedMetaMask() && window.ethereum.chainId === '0x4';
    // },
    // connectedMaticNetwork () {
    //   return this.connectedMetaMask() && window.ethereum.chainId === '0x89';
    // },
    async onSelectNFT(i){
      this.selectnft_index = i
      this.selectnft = '#image' + String(i)
      
      console.log("NFT String(i)",String(i))
      console.log("this.array_tokenid[this.selectcollection].length",this.array_tokenid[this.selectcollection].length)

      var elem 
      for(let cnt =0;cnt<this.array_tokenid[this.selectcollection].length;cnt++){
        elem = document.querySelector('#image' + String(cnt));
        elem.style.border = "none";
      }
      elem = document.querySelector(this.selectnft);
      elem.style.border = "5px dotted #FF0000";
    },
    async onSelectParts(i){
      this.selectparts_index = i
      this.selectparts = '#parts' + String(i)
      
      console.log("Parts String(i)",String(i))
      console.log("this.array_backparts.length",this.array_backparts.length)

      var elem 
      for(let cnt =0;cnt<this.array_backparts.length;cnt++){
        elem = document.querySelector('#parts' + String(cnt));
        elem.style.border = "none";
      }
      elem = document.querySelector(this.selectparts);
      elem.style.border = "5px dotted #FF0000";
    },
    async concatCanvas(base, asset){
      const canvas = document.querySelector(base);
      const ctx = canvas.getContext("2d");

      console.log("concatCanvas canvas.width:",canvas.width)
      console.log("concatCanvas canvas.height:",canvas.height)

      for(let i=0; i<asset.length; i++){
        console.log("concatCanvas i:",i)
        const image1 = await this.getImagefromCanvas(asset[i]);
        ctx.drawImage(image1, 0, 0, canvas.width, canvas.height);
      }
    },
    async getImagefromCanvas(id){
      return new Promise((resolve, reject) => {
        const image = new Image();
        const ctx = document.querySelector(id).getContext("2d");
        image.onload = () => resolve(image);
        image.onerror = (e) => reject(e);
        // console.log("concatCanvas ctx.canvas.toDataURL():",ctx.canvas.toDataURL())
        image.setAttribute('crossOrigin', 'anonymous');
        image.src = ctx.canvas.toDataURL();
      });
    },
    async onRadioChange(){
      this.isdownload = false;
    },
    async onClickConcat_gif(){
      this.ConcatLoad = true;

      // NFTの画像URLを取得
      let targetFrontUrl = this.array_tokenid[this.selectcollection][this.selectnft_index].image;
      targetFrontUrl = targetFrontUrl.replace('app_lock','app')
      console.log("targetFrontUrl:",targetFrontUrl)

      // 背景の画像URLを取得
      let filename = this.array_backparts[this.selectparts_index];
      console.log("backImageUrl:",filename);

      let para_mini = 0;
      if(this.mini == true){
        para_mini = 1;
      }

      // ガッチャンコするAPIコール
      const responce =
      await axios.get(GOUSEI_GIF_API + 
      '?back=' + BACK_URL + filename + 
      '&front=' + targetFrontUrl + 
      '&mini=' + para_mini);
      console.log("base64gif:",this.base64gif);

      await sleep(3000);  // たまに合成できないことがあるのでSleepおく
      this.base64gif = responce.data;

      this.isdownload = true;
      this.ConcatLoad = false;
    },
    async onClickConcat(){
      this.ConcatLoad = true;
      const board = document.querySelector("#base");
      board.setAttribute("width",this.width);
      board.setAttribute("height",this.height);
      const ctx = board.getContext("2d");
      ctx.clearRect(0,0,this.width,this.height);
      const chara = new Image();
      chara.src = this.array_backparts[this.selectparts_index];
      chara.onload = () => {
        ctx.drawImage(chara, 0, 0);
      };

      let targetUrl = this.array_tokenid[this.selectcollection][this.selectnft_index].image;
      // console.log("targetUrl:",targetUrl)
      targetUrl = targetUrl.replace('app_lock','app')
      console.log("targetUrl:",targetUrl)

      // CORS対策でNFT画像をBase64エンコードする
      // const base64Text = await axios.get(`https://getbase64url.azurewebsites.net/api/getbase64-gif?url=${targetUrl}`);
      const base64Text = await axios.get(`https://express.japaneast.cloudapp.azure.com/getbase64/?url=${targetUrl}`);
      
      await sleep(3000);  // たまに合成できないことがあるのでSleepおく
      console.log("base64Text:",base64Text)
      
      const board2 = document.querySelector("#asset");

      var optionWidth = this.width,optionHeight = this.height;
      if(this.mini == true){
        optionWidth = 1000;
        optionHeight = 1000
      }
      // board2.setAttribute("width",this.width);
      // board2.setAttribute("height",this.height);
      board2.setAttribute("width",optionWidth);
      board2.setAttribute("height",optionHeight);
      const ctx2 = board2.getContext("2d");
      ctx2.clearRect(0,0,this.width,this.height);
      const chara2 = new Image();
      chara2.src = base64Text.data;
      chara2.onload = () => {
        if(this.mini == true){
           ctx2.drawImage(chara2, 150, 150);
        }else{
          ctx2.drawImage(chara2, 0, 0);
        }
      };

      await this.concatCanvas("#concat", ["#base", "#asset"]);

      this.isdownload = true;
      this.ConcatLoad = false;
    },
    async onClickDownload(){
      let canvas = document.querySelector("#concat");

      let link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = "pfp.png";
      link.click();
    },
    
    async onClickDownloadGif(){
      let src = document.querySelector("#gifconcat").getAttribute("src");
      let blob = await this.toBlob(src);
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'pfp.gif'
      link.click()
    },
    async toBlob(base64) {
        var bin = atob(base64.replace(/^.*,/, ''));
        var buffer = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) {
            buffer[i] = bin.charCodeAt(i);
        }
        // Blobを作成
        try{
            var blob = new Blob([buffer.buffer], {
                type: 'image/gif'
            });
        }catch (e){
            return false;
        }
        return blob;
    },

    
     // async onSelectChange(){
    // },
  },
  computed: {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.container{
  text-align: center;
  width:70%;
  padding:20px;
}

@media screen and (max-width: 800px) {
  .container{
    width:100%;
    font-size: 16px;
  }
}

/* ボタン横幅カスタム */
.w-180px {
  width: 180px !important;
}

.StatsInfoStyle{
  text-align: left;
  display: inline-block;  /* テキスト左寄せのまま中央表示できる */
  margin:20px;
  /* padding:1.5em;
  border-radius:20px;
  background-color: whitesmoke; */
}

input[type=radio] {
  -ms-transform: scale(1.8, 1.8);
  -webkit-transform: scale(1.8, 1.8);
  transform: scale(1.8, 1.8);
  margin: 0 10px 0 0;
}
input[type=checkbox] {
  -ms-transform: scale(1.8, 1.8);
  -webkit-transform: scale(1.8, 1.8);
  transform: scale(1.8, 1.8);
  margin: 0 10px 0 0;
}


.collection-title{
  /* height: 100px; */
  font-weight: bold;
  font-size: x-large;
  margin:10px;

  /* display: flex;
  justify-content: center;
  flex-wrap: wrap; */
}
.collection-detail{
  font-weight:normal;
  font-size: small;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  /* margin: 0px,20px,0px,20px; */
}
.imagecollection {
    /* border: outset 10px #900; */
    border: 8px solid black;
    border-radius:20px;
}
.imagebox{
  margin:10px;
}
.box {
    inline-size: 120px;
    overflow-wrap: break-word;
}

	hr {
    border-width: 0 0 8px;
    border-style: solid;
    border-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 1"><circle fill="hsla(0, 0%, 65%, 1.0)" cx="1" cy="0.5" r="0.5"/></svg>') 0 0 100% repeat;
    width: 100%;
	}

/* Loding stye */
.loader {
  margin: 100px auto;
  font-size: 25px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  -webkit-animation: load5 1.1s infinite ease;
  animation: load5 1.1s infinite ease;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
@-webkit-keyframes load5 {
  0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em #000000, 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.5), -1.8em -1.8em 0 0em rgba(0,0,0, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.7), 1.8em -1.8em 0 0em #000000, 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.5), 1.8em -1.8em 0 0em rgba(0,0,0, 0.7), 2.5em 0em 0 0em #000000, 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.5), 2.5em 0em 0 0em rgba(0,0,0, 0.7), 1.75em 1.75em 0 0em #000000, 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.5), 1.75em 1.75em 0 0em rgba(0,0,0, 0.7), 0em 2.5em 0 0em #000000, -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.5), 0em 2.5em 0 0em rgba(0,0,0, 0.7), -1.8em 1.8em 0 0em #000000, -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.5), -1.8em 1.8em 0 0em rgba(0,0,0, 0.7), -2.6em 0em 0 0em #000000, -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.5), -2.6em 0em 0 0em rgba(0,0,0, 0.7), -1.8em -1.8em 0 0em #000000;
  }
}
@keyframes load5 {
  0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em #000000, 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.5), -1.8em -1.8em 0 0em rgba(0,0,0, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.7), 1.8em -1.8em 0 0em #000000, 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.5), 1.8em -1.8em 0 0em rgba(0,0,0, 0.7), 2.5em 0em 0 0em #000000, 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.5), 2.5em 0em 0 0em rgba(0,0,0, 0.7), 1.75em 1.75em 0 0em #000000, 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.5), 1.75em 1.75em 0 0em rgba(0,0,0, 0.7), 0em 2.5em 0 0em #000000, -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.5), 0em 2.5em 0 0em rgba(0,0,0, 0.7), -1.8em 1.8em 0 0em #000000, -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.5), -1.8em 1.8em 0 0em rgba(0,0,0, 0.7), -2.6em 0em 0 0em #000000, -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.5), -2.6em 0em 0 0em rgba(0,0,0, 0.7), -1.8em -1.8em 0 0em #000000;
  }
}

/* Loding stye */


</style>
